import { axiosHttp } from "@/util/axios.js";
import { sessionSto } from "../../util/sessionStorageManage.js";

/**
 * 获取首页商品展示
 */
export function getIndexGoods() {
  return axiosHttp.$getAxios("/access/getIndexGoods");
}

/**
 * 根据筛选条件获取产品列表
 * @param { priceRange, isLast, classNo } data
 */
export function getGoodsByCondition(data) {
  return axiosHttp.$getAxios("/access/getGoodsByCondition", data);
}

/**
 * 获取商品详细信息
 * @param { goodsNo } data
 */
export function getGoodsInfo(data) {
  return axiosHttp.$getAxios("/access/getGoodsInfo", data);
}

/**
 * 获取产品分类信息
 */
export async function getGoodsCategory() {
  let resList = [];
  // let list = sessionSto.$selectSession('GoodsCategory')
  // if(list){
  //   resList = JSON.parse(list)
  // }else{
  //   let res = await axiosHttp.$getAxios("/access/getGoodsCategory")
  //   resList = res.data
  //   sessionSto.$insertSessionStorage('GoodsCategory', resList)
  // }
  let res = await axiosHttp.$getAxios("/access/getGoodsCategory");
  resList = res.data;
  sessionSto.$insertSessionStorage("GoodsCategory", resList);
  return resList;
}

// 查询手册
export function searchProductGuide(sku) {
  let data = {
    sku: sku
  };
  return axiosHttp.$getAxios("/access/getGoodsGuide", data);
}



// WEBPACK FOOTER //
// ./src/apis/product/index.js